export const MEAL_GOAL_DEFS = {
    loss: {
        key: 'loss',
        title: 'Loss Day',
        intent: 'Support weight loss with lean protein and vegetables',
        expectations: [
            'Lean protein at program portion (Man: 6–8 oz per meal; Woman: 3–6 oz per meal)',
            'Two portions of vegetables per meal',
            'No starch, grains, rice, potatoes, or bread on loss days',
            'Avoid sweets, fried foods, creamy sauces, and oversized servings',
        ],
        examples: [
            'Grilled chicken breast (6 oz) with steamed broccoli and side salad',
            '1 cup vegetable soup with lean protein (fish or chicken)',
            'Scrambled egg whites with spinach and steamed green beans',
        ],
    },
    maintenance: {
        key: 'maintenance',
        title: 'Maintenance Day',
        intent: 'Sustain current weight with balanced nutrition',
        expectations: [
            'Balanced mix of protein, vegetables, and moderate carbs',
            'Reasonable portions; not restrictive but not indulgent',
            'Healthy fats like olive oil, avocado, nuts are fine',
            'Occasional small treat acceptable, but not a "splurge"',
        ],
        examples: [
            'Turkey sandwich on whole wheat, side salad with vinaigrette',
            '1 cup pasta with tomato sauce and grilled vegetables',
            'Salmon (5 oz) with roasted sweet potato and green beans',
        ],
    },
    reward: {
        key: 'reward',
        title: 'Reward Day',
        intent: 'Allow indulgence or celebration while staying mindful',
        expectations: [
            'Higher calorie or less nutrient-dense meals are acceptable',
            'Desserts, comfort foods, fried items, or rich sauces allowed',
            'Portions can be larger but not extreme binge',
            'Part of overall balance (not every day)',
        ],
        examples: [
            'Cheeseburger with fries',
            '2–3 slices of pizza with soda or beer',
            'Slice of chocolate cake with ice cream',
            'Fried chicken with mashed potatoes and gravy',
        ],
    },
};
